var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import produce from 'immer';
export var initialState = {
    item: null,
    itemLoaded: false,
    marketList: [],
    marketListLoaded: false,
    priceInfo: {
        low_card: null,
        low_cash: null,
        low_open: null,
        low_open_sale: null,
    },
    spec: [],
    related: [],
    stdpcSpec: {
        item: null,
        stdpcSpec: null,
    },
    stdpcOption: null,
    stdpcOptionLoaded: false,
    stdpcSelect: {
        originPrice: 0,
        price: 0,
        each: 1,
        addedChangeLenght: 0,
        addedChangePrice: 0,
        selectIdxArr: [],
        stdpc_item_list_type1: [],
        stdpc_item_list_type2: [],
        stdpc_item_list_type3: [],
        stdpc_item_list_type4: [],
    },
    productSelect: {
        each: 1
    },
    priceStateNumber: 3,
    priceStateText: "price",
    installmentMonthNum: 12,
    installment12Price: 0,
    installment24Price: 0,
    cardToOpenLowPrice: 0,
    detailPageType: 0,
    isPopUp: false,
};
export var ITEM_REQUEST = 'ITEM_REQUEST';
export var ITEM_SUCCESS = 'ITEM_SUCCESS';
export var ITEM_FAILURE = 'ITEM_FAILURE';
export var MARKET_LIST_REQUEST = 'MARKET_LIST_REQUEST';
export var MARKET_LIST_SUCCESS = 'MARKET_LIST_SUCCESS';
export var MARKET_LIST_FAILURE = 'MARKET_LIST_FAILURE';
export var SPEC_REQUEST = 'SPEC_REQUEST';
export var SPEC_SUCCESS = 'SPEC_SUCCESS';
export var SPEC_FAILURE = 'SPEC_FAILURE';
export var STDPC_SPEC_REQUEST = 'STDPC_SPEC_REQUEST';
export var STDPC_SPEC_SUCCESS = 'STDPC_SPEC_SUCCESS';
export var STDPC_SPEC_FAILURE = 'STDPC_SPEC_FAILURE';
export var STDPC_OPTION_REQUEST = 'STDPC_OPTION_REQUEST';
export var STDPC_OPTION_SUCCESS = 'STDPC_OPTION_SUCCESS';
export var STDPC_OPTION_FAILURE = 'STDPC_OPTION_FAILURE';
export var SET_STDPC_SELECT = 'SET_STDPC_SELECT';
export var SET_PRODUCT_SELECT = 'SET_PRODUCT_SELECT';
export var SET_PRICE_DATA = 'SET_PRICE_DATA';
export var SET_INSTALLMENT_MONTH = 'SET_INSTALLMENT_MONTH';
export var SET_INSTALLMENT_12_PRICE = 'SET_INSTALLMENT_12_PRICE';
export var SET_INSTALLMENT_24_PRICE = 'SET_INSTALLMENT_24_PRICE';
export var SET_CARD_OPEN_LOW_PRICE = 'SET_CARD_OPEN_LOW_PRICE';
export var SET_DETAIL_PAGE_TYPE = 'SET_DETAIL_PAGE_TYPE';
export var SET_DETAIL_POPUP_PAGE = 'SET_DETAIL_POPUP_PAGE';
var Reducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    return produce(state, function (draft) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        switch (action.type) {
            // item
            case ITEM_REQUEST: {
                break;
            }
            case ITEM_SUCCESS: {
                draft.itemLoaded = true;
                draft.item = action.data.item || null;
                draft.related = action.data.related || [];
                draft.stdpcSelect.originPrice = ((_b = (_a = action.data.item) === null || _a === void 0 ? void 0 : _a.minishop) === null || _b === void 0 ? void 0 : _b.price_b2c) || 0;
                break;
            }
            case ITEM_FAILURE: {
                draft.itemLoaded = true;
                break;
            }
            // market list
            case MARKET_LIST_REQUEST: {
                break;
            }
            case MARKET_LIST_SUCCESS: {
                draft.marketListLoaded = true;
                draft.marketList = action.data.market || [];
                draft.priceInfo.low_card = ((_c = action.data.price_info) === null || _c === void 0 ? void 0 : _c.low_card) || null;
                draft.priceInfo.low_cash = ((_d = action.data.price_info) === null || _d === void 0 ? void 0 : _d.low_cash) || null;
                draft.priceInfo.low_open = ((_e = action.data.price_info) === null || _e === void 0 ? void 0 : _e.low_open) || null;
                draft.priceInfo.low_open_sale = ((_f = action.data.price_info) === null || _f === void 0 ? void 0 : _f.low_open_sale) || null;
                break;
            }
            case MARKET_LIST_FAILURE: {
                draft.marketListLoaded = true;
                break;
            }
            // spec
            case SPEC_REQUEST: {
                break;
            }
            case SPEC_SUCCESS: {
                draft.spec = action.data || [];
                break;
            }
            case SPEC_FAILURE: {
                break;
            }
            // stdpc spec
            case STDPC_SPEC_REQUEST: {
                break;
            }
            case STDPC_SPEC_SUCCESS: {
                draft.stdpcSpec.item = ((_g = action.data) === null || _g === void 0 ? void 0 : _g.item) || null;
                draft.stdpcSpec.stdpcSpec = ((_h = action.data) === null || _h === void 0 ? void 0 : _h.stdpcSpec) || null;
                break;
            }
            case STDPC_SPEC_FAILURE: {
                break;
            }
            // stdpc option
            case STDPC_OPTION_REQUEST: {
                break;
            }
            case STDPC_OPTION_SUCCESS: {
                draft.stdpcOptionLoaded = true;
                draft.stdpcOption = action.data || null;
                break;
            }
            case STDPC_OPTION_FAILURE: {
                draft.stdpcOptionLoaded = true;
                break;
            }
            // stdpc select
            case SET_STDPC_SELECT: {
                draft.stdpcSelect = __assign(__assign({}, state.stdpcSelect), action.payload);
                break;
            }
            // product select
            case SET_PRODUCT_SELECT: {
                draft.productSelect = __assign(__assign({}, state.productSelect), action.payload);
                break;
            }
            // 가격정보 0: 단종 1: 일시품절 2: 가격비교예정 3: 정상
            case SET_PRICE_DATA: {
                draft.priceStateNumber = action.payload;
                if (action.payload === 0) {
                    draft.priceStateText = "단종";
                }
                else if (action.payload === 1) {
                    draft.priceStateText = "일시품절";
                }
                else if (action.payload === 2) {
                    draft.priceStateText = "가격비교 예정";
                }
                else if (action.payload === 3) {
                    draft.priceStateText = "price";
                }
                break;
            }
            case SET_INSTALLMENT_MONTH: {
                draft.installmentMonthNum = action.payload;
                break;
            }
            case SET_INSTALLMENT_12_PRICE: {
                draft.installment12Price = action.payload;
                break;
            }
            case SET_INSTALLMENT_24_PRICE: {
                draft.installment24Price = action.payload;
                break;
            }
            case SET_CARD_OPEN_LOW_PRICE: {
                draft.cardToOpenLowPrice = action.payload;
                break;
            }
            case SET_DETAIL_PAGE_TYPE: {
                draft.detailPageType = action.payload.detailPageType;
                break;
            }
            case SET_DETAIL_POPUP_PAGE: {
                draft.isPopUp = action.payload.isPopUp;
                break;
            }
            default: {
                break;
            }
        }
    });
};
export default Reducer;



//////////////////
// WEBPACK FOOTER
// ./src/detail/reducers/product.ts
// module id = 19
// module chunks = 0